<template>
  <transition name="fade">
    <div v-if="isVisible" class="backdrop"></div>
  </transition>
  <transition name="zoom">
    <div v-if="isVisible" class="modal fade show d-flex align-items-center justify-content-center" data-bs-target="#staticBackdrop">
      <div 
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="modal_size"
      >
        <div class="modal-content p-4">
          <div class="d-flex flex-row align-items-center justify-content-between">
            <span v-if="title_centered"></span>
            <h5 class="modal-title display-5">{{ title }}</h5>
            <button type="button" class="btn-close" @click="handleCancel" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
name: 'ModalComponent',
props: {
  title: {
    type: String,
    default: 'Modal Title',
  },
  title_centered: {
    type: Boolean,
    default: false, 
  },
  modal_size: {
    type: String,
    default: 'modal-xl',
  },
},
data() {
  return {
    isVisible: false,
  };
},
methods: {
  handleCancel() {
    this.hide()
    this.$emit('onCancel'); 
  },
  show() {
    document.body.style.overflow = 'hidden';
    this.isVisible = true;
  },
  hide() {
    document.body.style.overflow = 'auto';
    this.isVisible = false;
  },
},
};
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/functions"; 
@import "bootstrap/scss/variables"; 
@import "bootstrap/scss/mixins";


.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($body-tertiary-bg-dark, 0.8);
  z-index: 1040;
  pointer-events: all;
  overflow: hidden;
}

.modal {
  z-index: 1050; 
}

.modal-header{
    border:0
}

.modal-footer{
    border:0
}

.zoom-enter-active, .zoom-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.zoom-enter-from {
  transform: scale(0.5);
  opacity: 0;
}

.zoom-leave-to {
  transform: scale(0.5); 
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}
</style>
